<div [id]="'header-mobile-component-'+color" class="_header-mobile-component">
    <p class="_page-title">{{title}}</p>
</div>